import javascript from './images/javascript.png';
import html from './images/html.png';
import css from './images/css.png';
import mysql from './images/mysql.png';
import python from './images/python.png';
import nodejs from './images/nodejs.svg';
import android from './images/android-studio.png';
import wordpress from './images/wordpress.png';
import docker from './images/docker.png';
import kubernetes from './images/kubernetes.svg';
import php from './images/php.png';
import java from './images/java.png';
import vue from './images/vue.png';
import react from './images/react native.png';
import github from './images/github.png';
import csharp from './images/c-sharp.png';
import vscode from './images/vs-code.png';

const techLogos = [
  { src: javascript, alt: 'JavaScript' },
  { src: html, alt: 'HTML5' },
  { src: css, alt: 'CSS3' },
  { src: mysql, alt: 'MySQL' },
  { src: python, alt: 'Python' },
  { src: nodejs, alt: 'Node.js' },
  { src: android, alt: 'Android Studio' },
  { src: wordpress, alt: 'WordPress' },
  { src: docker, alt: 'docker' },
  { src: kubernetes, alt: 'kubernetes' },
  { src: php, alt: 'php' },
  { src: java, alt: 'java' },
  { src: vue, alt: 'vue' },
  { src: react, alt: 'react' },
  { src: github, alt: 'github' },
  { src: csharp, alt: 'c-sharp' },
  { src: vscode, alt: 'vs-code' }
];

export default techLogos;
